import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ReuseTabService } from '../reuse-tab';
import { LocalStorageService } from './local-storage.service';
import { MessageService } from 'primeng/api';
import { saveAs } from 'file-saver';
import { TranslateService } from '@ngx-translate/core';
import { DisableButton } from '../models/General/DisableButton';
import { ApiJsonResult } from '../models/General/ApiJsonResult';
// import * as $ from 'jquery';

@Injectable({
    providedIn: 'root',
})
export class CommonService {
    public showLoader = { value: false };// để hiển thị cái loading khi mà load tải báo cáo hoặc tải file excel
    public dialogMobile: boolean;
    public lang0: string = "";
    public lang1: string = "";
    public lang2: string = "";
    public demo: boolean;
    public fromDate: Date;
    public toDate: Date;
    public fromDate2: Date;
    public toDate2: Date;
    constructor(private http: HttpClient,
        private reuseTabService: ReuseTabService,
        private localStorageService: LocalStorageService,
        public translate: TranslateService,
    ) {
        if (window.innerWidth <= 1200) {
            this.dialogMobile = true;
        } else {
            this.dialogMobile = false;
        }
        // if(localStorage.getItem("langPack") != null && localStorage.getItem("langPack") != undefined && localStorage.getItem("langPack") != ""){
        //     let langPack : string = this.localStorageService.getItem("langPack");
        //     let lang : string[] = langPack.split("-");
        //     this.lang0 = lang[0];
        //     this.lang1 = lang[1];
        //     this.lang2 = lang[2];
        // }
        this.demo = true;
        if (this.demo) {
            this.fromDate = new Date("Jan 01, 2019");
            this.toDate = new Date("Dec 31, 2019");
            this.fromDate2 = new Date("Jan 01, 2020");
            this.toDate2 = new Date("Dec 31, 2020");
        }
    }

    // 
    getTranlation(string: string): string { // get from file language to transalte and show
        let result = "";
        this.translate.get(string).subscribe(val => result = val);
        return result;
    }

    showSuccess(messageService: MessageService, message: string) {
        messageService.add({ severity: 'success', summary: 'Success Message', detail: message});
    }

    showError(messageService: MessageService, message: string) {
        messageService.add({ severity: 'error', summary: 'Error Message', detail: message, life: 7000 });
    }

    showInfo(messageService: MessageService, message: string) {
        messageService.add({ severity: 'info', summary: 'Info Message', detail: message, life: 4000 });
    }

    showErrorDownloadExcel(messageService: MessageService) {
        messageService.add({ severity: 'error', summary: 'Error Message', detail: (this.getLanguage() == "VN" ? "Gửi yêu cầu tải excel file tới máy chủ bị lỗi, vui lòng thử lại !" : "Send request download excel file to server have a error, please send again !"), life: 7000 });
    }

    showErrorDownloadFile(messageService: MessageService) {
        messageService.add({ severity: 'error', summary: 'Error Message', detail: (this.getLanguage() == "VN" ? "Gửi yêu cầu tải file tới máy chủ bị lỗi, vui lòng thử lại !" : "Send request download file to server have a error, please send again !"), life: 7000 });
    }

    showErrorLoadReport(messageService: MessageService) {
        messageService.add({ severity: 'error', summary: 'Error Message', detail: (this.getLanguage() == "VN" ? "Gửi yêu cầu hiển thị báo cáo tới máy chủ bị lỗi, vui lòng thử lại !" : "Send request show report to server have a error, please send again !"), life: 7000 });
    }

    showSuccessLoadReport(messageService: MessageService) {
        messageService.add({ severity: 'success', summary: 'Success Message', detail: (this.getLanguage() == "VN" ? "Lấy báo cáo thành công !" : "Load report successfully !"), life: 3000 });
    }

    showSuccessDownloadExcel(messageService: MessageService) {
        messageService.add({ severity: 'success', summary: 'Success Message', detail: (this.getLanguage() == "VN" ? "Tải excel file thành công !" : "Download excel file successfully !"), life: 3000 });
    }

    showSuccessDownloadFile(messageService: MessageService) {
        messageService.add({ severity: 'success', summary: 'Success Message', detail: (this.getLanguage() == "VN" ? "Tải file thành công !" : "Download file successfully !"), life: 3000 });
    }

    showErrorRequest(messageService: MessageService) {
        messageService.add({ severity: 'error', summary: 'Error Message', detail: (this.getLanguage() == "VN" ? "Gửi yêu cầu tới máy chủ bị lỗi, vui lòng thử lại !" : "Send request to server have a error, please send again !"), life: 7000 });
    }

    messageErrorBeginForm(): string{
        return this.getLanguage() == "VN" ? "Khởi tạo dữ liệu ban đầu gặp lỗi. Vui lòng mở lại Form !" : "Initial data initialization has encountered an error. Please reopen the form !";
    }
    
    getUrlCurrent(): string {
        return this.reuseTabService.curUrl;
    }

    checkContainUrl(url?: string): boolean{
        let index = this.reuseTabService.items.findIndex(e => e.url == url);
        if(index > -1) return true;
        else return false;
    }

    removeTab(url: string) {
        this.reuseTabService.close(url);
        return
    }

    getLanguage(): string {
        return this.localStorageService.getItem("language");
    }

    getData(url: string) {
        return this.http.get(`${environment.apiUrl}/` + url);
    }

    getDataToForm(data?: any, formName?: string, tabKey?: string) {
        return this.http.post(`${environment.apiUrl}/api/` + formName + ((tabKey && tabKey != "General") ? ("/" + tabKey) : "") + `/refresh`, data);
    }

    save(data?: any, formName?: string, tabKey?: string) {
        return this.http.post(`${environment.apiUrl}/api/` + formName + ((tabKey && tabKey != "General") ? ("/" + tabKey) : "") + `/save`, data);
    }

    getDataParams(url: string, params: any[]) {
        // params = [[params, value],[params, value]]
        let paramsT = new HttpParams();
        params.forEach(element => {
            paramsT = paramsT.append(`${element[0]}`, `${element[1]}`)
        });
        return this.http.get(`${environment.apiUrl}/` + url, { params: paramsT });
    }

    getDataWithPost(url: string, data : any) {
        return this.http.post(`${environment.apiUrl}/` + url, data);
    }

    getDataWithPostCustomHeader(url: string, data? : any) {
        return this.http.post(`${environment.apiUrl}/` + url, data, {headers : new HttpHeaders({ 'Content-Type': 'application/json'})});
    }

    getDataWithPostProgressSpinner(url: string, data: any, destination: any, messageService: MessageService, message: string) {
        this.showLoader.value = true;// pass object to reference
        return this.http.post(`${environment.apiUrl}/` + url, data).subscribe(
            (res: any) => {
                destination.data = res.Data;
            },
            err => {
                this.showError(messageService, this.getLanguage() == "VN" ? "Tải dữ liệu " + message + " bị lỗi, Vui lòng thử lại !" : "Load data " + message + " have a error, please send again !");
                this.showLoader.value = false;
            },
            () => {
                this.showLoader.value = false;
            });
    }

    inputTemplateFile(fileToUpload: File, url: string){
        let formData = new FormData();
        formData.append('fileKey', fileToUpload, fileToUpload.name);
        return this.http
            .post(`${environment.apiUrl}/` + url, formData);
    }

    inputTemplateFileWithJson(fileToUpload: File, data: any, url: string){
        let formData = new FormData();
        formData.append('fileKey', fileToUpload, fileToUpload.name);

        formData.append('data', JSON.stringify(data));

        return this.http
            .post(`${environment.apiUrl}/` + url, formData);
    }

    inputTemplateFollowTime(fileToUpload: File,tableName: string){
        let formData = new FormData();
        formData.append('fileKey', fileToUpload, fileToUpload.name);
        formData.append('tableName', tableName);
        return this.http
            .post(`${environment.apiUrl}/api/general/hrform/input_template_follow_time`, formData);
    }

    getTemplateFollowTime(employeeList: any[],fromDate: string,toDate: string, messageService?: MessageService){
        let formData = new FormData();
        formData.append('employeeList', JSON.stringify(employeeList));
        formData.append('fromDate', fromDate);
        formData.append('toDate', toDate);
        this.showLoader.value = true;// pass object to reference
        return this.http.post(`${environment.apiUrl}/api/general/hrform/get_template_follow_time`, formData, { responseType: 'blob' }).subscribe(res => {
            if (res.type == "text/plain") {
                const data = new Blob([res], { type: 'text/plain' });
                // data['text']();data.text()
                data['text']().then(text => {
                    this.showError(messageService, this.getTranlation(text));
                });
            }
            else if (res.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || res.type == "application/vnd.ms-excel" || res.type == "application/octet-stream") {
                let data = new Blob([res], { type: res.type });
                saveAs(data, "TempNhapTheoThoiGian.xlsx");
                this.showSuccessDownloadExcel(messageService);
            }
            else {
                this.showError(messageService, this.getLanguage() == "VN" ? "Kiểu dữ liệu phản hồi không đúng định dạng" : "The response data type is malformed");
            }
        },
            err => {
                this.showErrorDownloadExcel(messageService);
                this.showLoader.value = false;
            },
            () => {
                this.showLoader.value = false;
            });
    }

    loadPDFReportProgressSpinner(data?: any, pdfViewerOnDemand?: any, messageService?: MessageService, url?: string) {
        this.showLoader.value = true;// pass object to reference
        return this.http.post(`${environment.apiUrl}/` + url, data, { responseType: 'blob' }).pipe(
            map((result: any) => result))
            .subscribe(
                (res) => {
                    if (res.type == "text/plain") {
                        const data = new Blob([res], { type: 'text/plain' });
                        // data['text']();data.text()
                        data['text']().then(text => {
                            this.showError(messageService, this.getTranlation(text));
                        });
                    }
                    else if (res.type == "application/octet-stream") {
                        pdfViewerOnDemand.pdfSrc = res; // pdfSrc can be Blob or Uint8Array
                        pdfViewerOnDemand.refresh(); // Ask pdf viewer to load/reresh pdf
                        this.showSuccessLoadReport(messageService);
                    }
                    else {
                        this.showError(messageService, this.getLanguage() == "VN" ? "Kiểu dữ liệu phản hồi không đúng định dạng" : "The response data type is malformed");
                    }
                },
                err => {
                    this.showErrorLoadReport(messageService);
                    this.showLoader.value = false;
                },
                () => {
                    this.showLoader.value = false;
                });
    }

    downloadExcelProgressSpinner(data: any, fileName: string, messageService: MessageService, url: string) {
        this.showLoader.value = true;// pass object to reference show Progress Spinner
        return this.http.post(`${environment.apiUrl}/` + url, data, { responseType: 'blob' }).subscribe(res => {
            if (res.type == "text/plain") {
                const data = new Blob([res], { type: 'text/plain' });
                // data['text']();data.text()
                data['text']().then(text => {
                    this.showError(messageService, this.getTranlation(text));
                });
            }
            else if (res.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || res.type == "application/vnd.ms-excel" || res.type == "application/octet-stream") {
                let data = new Blob([res], { type: res.type });
                saveAs(data, fileName);
                this.showSuccessDownloadExcel(messageService);
            }
            else {
                this.showError(messageService, this.getLanguage() == "VN" ? "Kiểu dữ liệu phản hồi không đúng định dạng" : "The response data type is malformed");
            }
        },
            err => {
                this.showErrorDownloadExcel(messageService);
                this.showLoader.value = false;
            },
            () => {
                this.showLoader.value = false;
            });
    }

    btnDownloadExcelInParaNV(data: any, justOpen: boolean, fileName: string, messageService: MessageService, url: string, otherMessage?: string) {
        const paramsT = new HttpParams().append('justOpen', justOpen ? "true" : "false");
        this.showLoader.value = true;// pass object to reference show Progress Spinner
        return this.http.post(`${environment.apiUrl}/` + url, data, { params: paramsT, responseType: 'blob' }).subscribe(res => {
            if (res.type == "text/plain") {
                const data = new Blob([res], { type: 'text/plain' });
                // data['text']();data.text()
                data['text']().then(text => {
                    this.showError(messageService, this.getTranlation(text));
                });
            }
            else if (res.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || res.type == "application/vnd.ms-excel" || res.type == "application/octet-stream") {
                let data = new Blob([res], { type: res.type });
                saveAs(data, fileName);
                this.showSuccessDownloadExcel(messageService);
                if (otherMessage) { this.showSuccess(messageService, this.getTranlation(otherMessage)); }
            }
            else {
                this.showError(messageService, this.getLanguage() == "VN" ? "Kiểu dữ liệu phản hồi không đúng định dạng" : "The response data type is malformed");
            }
        },
            err => {
                this.showErrorDownloadExcel(messageService);
                this.showLoader.value = false;
            },
            () => {
                this.showLoader.value = false;
            });
    }

    downloadFile(data: any, fileName: string, messageService: MessageService, url: string, otherMessage?: string) {
        this.showLoader.value = true;// pass object to reference show Progress Spinner
        return this.http.post(`${environment.apiUrl}/` + url, data, { responseType: 'blob' }).subscribe(res => {
            if (res.type == "text/plain") {
                const data = new Blob([res], { type: 'text/plain' });
                // data['text']();data.text()
                data['text']().then(text => {
                    this.showError(messageService, this.getTranlation(text));
                });
            }
            else if (res.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || res.type == "application/octet-stream" || res.type == "application/vnd.ms-excel") {
                let data = new Blob([res], { type: res.type });
                saveAs(data, fileName);
                this.showSuccessDownloadExcel(messageService);
                if (otherMessage) { this.showSuccess(messageService, this.getTranlation(otherMessage)); }
            }
            else {
                this.showError(messageService, this.getLanguage() == "VN" ? "Kiểu dữ liệu phản hồi không đúng định dạng" : "The response data type is malformed");
            }
        },
            err => {
                this.showErrorDownloadExcel(messageService);
                this.showLoader.value = false;
            },
            () => {
                this.showLoader.value = false;
            });
    }

    public CheckFromToDate(fromDate?: Date, toDate?: Date, messageService?: MessageService): boolean {
        if (fromDate != null && toDate != null && toDate >= fromDate) {
            return true;
        }
        else if (fromDate == null) {
            this.focusInput("fromdate");
            this.showError(messageService, "Please entry from date");
            return false;
        }
        else if (toDate == null) {
            this.focusInput("todate");
            this.showError(messageService, "Please entry to date");
            return false;
        }
        else {
            this.focusInput("fromdate");
            this.showError(messageService, "FromDate <= ToDate");
            return false;
        }
    }

    //xử trường hợp làm tròn 10.5 -> 11
    Roundss(value: number, digits: number = 0): number {
        if (digits == 0) {
            return Math.round(value + Number.EPSILON);
        } else if (digits == 1) {
            return Math.round((value + Number.EPSILON) * 10) / 10;
        } else if (digits == 2) {
            return Math.round((value + Number.EPSILON) * 100) / 100;
        } else if (digits == 3) {
            return Math.round((value + Number.EPSILON) * 1000) / 1000;
        } else if (digits == 4) {
            return Math.round((value + Number.EPSILON) * 10000) / 10000;
        } else if (digits == 5) {
            return Math.round((value + Number.EPSILON) * 100000) / 100000;
        } else if (digits == 6) {
            return Math.round((value + Number.EPSILON) * 1000000) / 1000000;
        } else if (digits == 7) {
            return Math.round((value + Number.EPSILON) * 10000000) / 10000000;
        }
        else return Math.round((value + Number.EPSILON) * 100000000) / 100000000;
    }

    // validate input require
    public validate(requiredProperties: string[], Ojb: any, messageService: MessageService): boolean {
        if (requiredProperties) {
            for (let i = 0; i < requiredProperties.length; i++) {
                if(typeof Ojb[requiredProperties[i]] === "number"){
                    if(Ojb[requiredProperties[i]] == null || Ojb[requiredProperties[i]] == undefined){
                        this.focusInput(requiredProperties[i]);
                        this.showError(messageService, this.getTranlation('Popup.Banvuilongnhapdulieuvaonhungcotmaudo'));
                        return false; // break;
                    }
                }
                else if(typeof Ojb[requiredProperties[i]] === "boolean"){
                    if(Ojb[requiredProperties[i]] == null || Ojb[requiredProperties[i]] == undefined){
                        this.focusInput(requiredProperties[i]);
                        this.showError(messageService, this.getTranlation('Popup.Banvuilongnhapdulieuvaonhungcotmaudo'));
                        return false; // break;
                    }
                }
                else if (!Ojb[requiredProperties[i]]) {
                    this.focusInput(requiredProperties[i]);
                    this.showError(messageService, this.getTranlation('Popup.Banvuilongnhapdulieuvaonhungcotmaudo'));
                    return false; // break;
                }
            }
            return true;
        }
        else return true;
    }

    //Const Dropdown
    public getNameOfValueFromDropDown(dropdown?: any[], value?: string) {
        if (value == null || value == "") {
            return "";
        }
        else if (dropdown == null || dropdown.length == 0) {
            return value;
        }
        else {
            let dr = dropdown.find(element => element.Code == value);
            if (dr) return dr.Name;
            else return value;
        }
    }

    public getNameOfValueFromDropDownDetail(dropdown?: any[], value?: string) {
        if (value == null || value == "") {
            return "";
        }
        else if (dropdown == null || dropdown.length == 0) {
            return value;
        }
        else {
            let dr = dropdown.find(element => element.Category == value);
            if (dr) {
                if (this.getLanguage() == "VN") return dr.NameVN;
                else if (this.getLanguage() == "EN") return dr.NameEN;
                else return dr.NameKR;
            }
            else return value;
        }
    }

    public getLableFromDropDown(dropdown: any[], value: string) {
        let dr = dropdown.find(element => element.value == value);
        if (dr) return dr.label;
        else return value;
    }

    public getNameOfValueFromDropDownShift(dropdown?: any[], value?: string) {
        if (value == null || value == "") {
            return "";
        }
        else if (dropdown == null || dropdown.length == 0) {
            return value;
        }
        else {
            let dr = dropdown.find(element => element.ShiftName == value);
            if (dr) return dr.ShiftSign;
            else return value;
        }
    }

    public getNewDropDown() {
        return [
            { label: '', value: null },
        ];
    }

    public getNewDropDownSalaryComponentComponent() {
        return [
            { SalaryComponent: null, NameVN: null, NameEN: null, MonthlyChanging: null},
        ];
    }

    public getNewDropDownDetailCommon() {
        return [
            { Category: null, NameVN: null, NameEN: null, NameKR: null },
        ];
    }

    public getNewDropDownJobCodeDetail() {
        return [
            { JobCode: null, Name: null, HAZARD: null, ToxicPercent: null },
        ];
    }

    public getNewDropDownLeaveType() {
        return [
            { MaCong: null, LoaiCong: null, NameVN: null, NameEN: null, NameKR: null },
        ];
    }

    public getNewDropDownShift() {
        return [
            { ShiftSign: null, ShiftName: null, FromTime: null, ToTime: null, RestTimeFrom: null, RestTimeTo: null },
        ];
    }

    public getNewDropDownCommon() {
        return [
            { Code: null, Name: null },
        ];
    }

    public appendDropDownDetailCommon(appendedData?: any[]) {
        let dataBegin = [
            { Category: null, NameVN: null, NameEN: null, NameKR: null },
        ];
        if (appendedData) {
            appendedData.forEach(element => {
                dataBegin.push({ Category: element.Category, NameVN: element.NameVN, NameEN: element.NameEN, NameKR: element.NameKR });
            });
        }
        return dataBegin;
    }

    public appendDropDownJobCodeDetail(appendedData?: any[]) {
        let dataBegin = [
            { JobCode: null, Name: null, HAZARD: null, ToxicPercent: null },
        ];
        if (appendedData) {
            appendedData.forEach(element => {
                dataBegin.push({ JobCode: element.JobCode, Name: element.Name, HAZARD: element.HAZARD, ToxicPercent: element.ToxicPercent });
            });
        }
        return dataBegin;
    }

    public appendDropDownShift(appendedData?: any[]) {
        let dataBegin = [
            { ShiftSign: null, ShiftName: null, FromTime: null, ToTime: null, RestTimeFrom: null, RestTimeTo: null },
        ];
        if (appendedData) {
            appendedData.forEach(element => {
                dataBegin.push({ ShiftSign: element.ShiftSign, ShiftName: element.ShiftName, FromTime: element.FromTime, ToTime: element.ToTime, RestTimeFrom: element.RestTimeFrom, RestTimeTo: element.RestTimeTo  });
            });
        }
        return dataBegin;
    }

    public appendDropDownSalary(appendedData?: any[]) {
        let dataBegin = [
            { SalaryComponent: null, NameVN: null, NameEN: null, Insurance: null, MonthlyChanging: null },
        ];
        if (appendedData) {
            appendedData.forEach(element => {
                dataBegin.push({ SalaryComponent: element.SalaryComponent, NameVN: element.NameVN, NameEN: element.NameEN, Insurance: element.Insurance, MonthlyChanging: element.MonthlyChanging});
            });
        }
        return dataBegin;
    }

    public appendDropDownLeaveType(appendedData?: any[]) {
        let dataBegin = [
            { MaCong: null, LoaiCong: null, NameVN: null, NameEN: null, NameKR: null },
        ];
        if (appendedData) {
            appendedData.forEach(element => {
                dataBegin.push({ MaCong: element.MaCong, LoaiCong: element.LoaiCong, NameVN: element.NameVN, NameEN: element.NameEN, NameKR: element.NameKR});
            });
        }
        return dataBegin;
    }

    public appendDropDownCommon(appendedData?: any[]) {
        let dataBegin = [
            { Code: null, Name: null },
        ];
        if (appendedData) {
            appendedData.forEach(element => {
                dataBegin.push({ Code: element.Code, Name: element.Name });
            });
        }
        return dataBegin;
    }

    public appendDropDown(appendedData?: any[]) {
        let dataBegin = [
            { label: '', value: null },
        ];
        if (appendedData) {
            appendedData.forEach(element => {
                dataBegin.push({ label: element.Code, value: element.Code });
            });
        }
        if (dataBegin.length > 1) {
            dataBegin.shift(); // remove cái dòng đầu đi
        }

        return dataBegin;
    }

    // const 
    public getNewDropDownInOut() {
        return [
            { label: '', value: null },
            { label: 'In / Vào', value: 'I' },
            { label: 'Out / Ra', value: 'O' },
        ];
    }

    public getNewDropDownDateFormat() {
        return [
            { label: 'dd/MM/yyyy', value: 'dd/MM/yyyy' },
            { label: 'MM/yyyy', value: 'MM/yyyy' },
            { label: 'yyyy', value: 'yyyy' },
        ];
    }

    public getNewDropDownSex() {
        return [
            { label: '', value: null },
            { label: 'Male', value: 'Male' },
            { label: 'Female', value: 'Female' },
        ];
    }

    public getNewDropDownMaritalStatus() {
        return [
            { label: '', value: null },
            { label: 'Single', value: 'Single' },
            { label: 'Married', value: 'Married' },
        ];
    }

    public getNewDropDownNationality() {
        return [
            { label: '', value: null },
            { label: 'Vietnamese', value: 'Vietnamese' },
            { label: 'Non-Vietnamese', value: 'Non-Vietnamese' },
        ];
    }

    public getDropDownMoth() {
        return [
            { label: 1, value: 1 },
            { label: 2, value: 2 },
            { label: 3, value: 3 },
            { label: 4, value: 4 },
            { label: 5, value: 5 },
            { label: 6, value: 6 },
            { label: 7, value: 7 },
            { label: 8, value: 8 },
            { label: 9, value: 9 },
            { label: 10, value: 10 },
            { label: 11, value: 11 },
            { label: 12, value: 12 }
        ];
    }
    // const 
    public getDropDownYear() {
        return [
            { label: 2006, value: 2006 },
            { label: 2007, value: 2007 },
            { label: 2008, value: 2008 },
            { label: 2009, value: 2009 },
            { label: 2010, value: 2010 },
            { label: 2011, value: 2011 },
            { label: 2012, value: 2012 },
            { label: 2013, value: 2013 },
            { label: 2014, value: 2014 },
            { label: 2015, value: 2015 },
            { label: 2016, value: 2016 },
            { label: 2018, value: 2018 },
            { label: 2019, value: 2019 },
            { label: 2020, value: 2020 },
            { label: 2021, value: 2021 },
            { label: 2022, value: 2022 },
            { label: 2023, value: 2023 }
        ];
    }

    public trackByID = (index, item) => {
        if (item == null) return item;
        else return item.ID;
    }

    public focusInput(id: string) {
        if (document.getElementById(id))
            document.getElementById(id).focus();
    }

    public focusInputTimeout(id: string) {
        setTimeout(() => {
            if (document.getElementById(id))
                document.getElementById(id).focus()
        }, 100);
    }

    public ArrayBufferToBase64(buffer: ArrayBuffer) {
        let binary = '';
        let bytes = new Uint8Array(buffer);
        let len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }

    public Base64ToArrayBuffer(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    }

    public AddSrcImage(base64String?: any, id?: string) {
        if (base64String) {
            (<HTMLImageElement>document.getElementById(id)).src = "data:image/png;base64," + base64String;
        }
        else {
            (<HTMLImageElement>document.getElementById(id)).src = "";
        }
    }
    public RemoveSrcImage(id: string) {
        (<HTMLImageElement>document.getElementById(id)).src = "";
    }

    public addPaddingScrollVirtual(isManyTab?: boolean, isFrozenColumns?: boolean) {
        const element = document.getElementsByClassName('cdk-virtual-scroll-content-wrapper');
        if (element) {
            for (let i = 0; i < element.length; i++) {
                if (isManyTab && isFrozenColumns) {
                    if (i % 2 == 0) {
                        if (!element[i].classList.contains("fix-padding-right-virtual"))
                            element[i].classList.add('fix-padding-right-virtual');
                    }
                }
                else if (isManyTab && !isFrozenColumns) {
                    if (!element[i].classList.contains("fix-padding-right-virtual"))
                        element[i].classList.add('fix-padding-right-virtual');
                }
                else if (!isManyTab && isFrozenColumns) {
                    if (i % 2 == 1) {
                        if (!element[i].classList.contains("fix-padding-right-virtual"))
                            element[i].classList.add('fix-padding-right-virtual');
                    }
                }
                else {
                    if (!element[0].classList.contains("fix-padding-right-virtual") && element.length == 1)
                        element[0].classList.add('fix-padding-right-virtual');
                }
            }
        }
    }

    public removePaddingScrollVirtual(isManyTab?: boolean, isFrozenColumns?: boolean) {
        const element = document.getElementsByClassName('cdk-virtual-scroll-content-wrapper');
        if (element) {
            for (let i = 0; i < element.length; i++) {
                if (isManyTab && isFrozenColumns) {
                    if (i % 2 == 0) {
                        element[i].classList.remove('fix-padding-right-virtual');
                    }
                }
                else if (isManyTab && !isFrozenColumns) {
                    element[i].classList.remove('fix-padding-right-virtual');
                }
                else if (!isManyTab && isFrozenColumns) {
                    if (i % 2 == 1) {
                        element[i].classList.remove('fix-padding-right-virtual');
                    }
                }
                else {
                    if (element.length == 1)
                        element[0].classList.remove('fix-padding-right-virtual');
                }
            }

        }
    }
    // mỗi tab chỉ có 1 table và table đó có frozen columns hay k
    public handleErrorWidthScrollVirtual(lengthData?: any, isManyTab?: boolean, isFrozenColumns?: boolean) {
        if (lengthData < 14 && !this.dialogMobile) this.addPaddingScrollVirtual(isManyTab, isFrozenColumns);
        else this.removePaddingScrollVirtual(isManyTab, isFrozenColumns);
    }

    //this.commonService.setColorBlueHeaderTable(this.columnsInfor);
    public setColorBlueHeaderTable(colums?: string[]){
        setTimeout(() => {
            if(colums){
                colums.forEach(e => {
                    let element = document.getElementById("th" + e);
                    if (element) {
                        element.classList.add("color-blue"); 
                    }
                });
            }
        }, 100);
    }

    //this.commonService.setColorRedHeaderTable(this.requiredProperties);
    public setColorRedHeaderTable(colums?: string[]){
        setTimeout(() => {
            if(colums){
                colums.forEach(e => {
                    let element = document.getElementById("th" + e);
                    if (element) {
                        element.classList.add("font-color-red");
                    }
                });
            }
        }, 102);
    }

    public setDisableButton(columnsVisible? : string[],requiredProperties? : string[], disableButton?: DisableButton){
        disableButton.Delete = false;
        disableButton.Save = false;
        if(columnsVisible && requiredProperties){
            if(requiredProperties.every(v => columnsVisible.includes(v))){
                disableButton.Delete = true;
                disableButton.Save = true;
            }
        }
    }
}
